<template>
  <div class="cart">
    <header-section :subnav_show="false" :change_color="true" :cart_change="cart_change"></header-section>

      <!--<div class="cart_body">-->
          <div class="cart_body">

          <div class="step_bar">
              <div class="step">
                  <el-steps :active="0" simple>
                      <el-step title="我的购物车" icon="el-icon-shopping-cart-full"></el-step>
                      <el-step title="物流地址" icon="el-icon-map-location"></el-step>
                      <el-step title="生成订单" icon="el-icon-check"></el-step>
                      <!-- <el-step title="选择支付" icon="el-icon-mouse"></el-step>
                      <el-step title="支付成功" icon="el-icon-check"></el-step> -->
                  </el-steps>
              </div>
          </div>

          <!-- 店铺和商品列表 -->
          <!--<div class="store_goods_list">-->
              <!--<div class="store_goods_list_title">-->
                  <!--<el-row>-->
                      <!--<el-col :span="4"><el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox></el-col>-->
                      <!--<el-col :span="10">商品</el-col>-->
                      <!--<el-col :span="2">单价（元）</el-col>-->
                      <!--<el-col :span="4">数量</el-col>-->
                      <!--<el-col :span="2">小计</el-col>-->
                      <!--<el-col :span="2">操作</el-col>-->
                  <!--</el-row>-->
              <!--</div>-->
          <!--</div>-->
          <div class="store_goods_list" v-if="cart_list.length>0">
              <!--<div class="store_goods_all_store_info" v-for="(v,k) in cart_list" :key="k">-->
                  <!--<el-checkbox :indeterminate="store_list_check[k].chose" v-model="store_list_check[k].check" @change="handleStoreChange(k)">{{v[0].store_name}}<span>进入店铺</span></el-checkbox>-->
                  <!--<ul>-->
                      <!--<li v-for="(vo,key) in v" :key="key">-->
                          <!--<el-row>-->
                              <!--<el-col :span="1"><el-checkbox v-model="vo.check" @change="handleCartListChange(key,k)"></el-checkbox></el-col>-->
                              <!--<el-col :span="13">-->
                                  <!--<div class="goods_thumb"><img width="40px" height="40px" :src="vo.image" alt=""></div>-->
                                  <!--<div class="goods_title"><router-link to="/">{{vo.goods_name}}</router-link></div>-->
                              <!--</el-col>-->
                              <!--<el-col :span="2"><div class="price">￥{{vo.goods_price}}</div></el-col>-->
                              <!--<el-col :span="4">-->
                                  <!--<div class="jian" @click="change_cart(vo,1,0)"><i class="el-icon-minus"></i></div>-->
                                  <!--<div class="nums"><input disabled v-model="vo.goods_num" type="text"></div>-->
                                  <!--<div class="jia" @click="change_cart(vo,1,1)"><i class="el-icon-plus"></i></div>-->
                              <!--</el-col>-->
                              <!--<el-col :span="2"><div class="price" style="color:#333;font-weight:bold;">￥{{vo.goods_num*vo.goods_price}}</div></el-col>-->
                              <!--<el-col :span="2"><div class="remove" @click="del_cart(vo)">移除</div></el-col>-->
                          <!--</el-row>-->
                      <!--</li>-->
                  <!--</ul>-->
              <div class="cart_th">
                <el-row>
                    <el-col :span="8">
                        <span class="goods">商品</span>
                    </el-col>
                    <el-col :span="5">
                        <span class="attr">规格</span>
                    </el-col>
                    <!-- <el-col :span="3">
                        <span class="price">单价（元）</span>
                    </el-col> -->
                    <el-col :span="5">
                        <span class="num">数量</span>
                    </el-col>
                    <!-- <el-col :span="3">
                        <span class="total">小计</span>
                    </el-col> -->
                    <el-col :span="5">
                        <span class="handle">操作</span>
                    </el-col>
                </el-row>
              </div>
          <div class="cart_table" >
          <div class="goods_list">
              <ul>
                  <li v-for="(vo,key) in cart_list" :key="key">
                    <el-row>
                        <el-col :span="8">
                            <span class="checkbox_goods">
                                <el-checkbox v-model="vo.checked" @change="handleCartListChange(vo)"></el-checkbox>
                            </span>
                            <router-link :to="'/product/detail/'+vo.goodsId">
                                <dl class="goods_item">
                                    <dt><img :src="vo.picUrl||'@/static/img/public/loading_pic_200.png'" :alt="vo.goods_name"></dt>
                                    <dd>{{vo.goodsName}}</dd>
                                </dl>
                            </router-link>
                        </el-col>
                        <el-col :span="5">
                            <span class="attr">{{vo.specifications}}</span>
                        </el-col>
                        <!-- <el-col :span="3">
                            <span class="price">￥{{vo.price}}</span>
                        </el-col> -->
                        <el-col :span="5">
                            <span class="num">
                                <font @click="change_cart(vo,0)" style="cursor:pointer"><i class="el-icon-minus"></i></font>
                                <input type="text" disabled v-model="vo.number" style="height:25px"/>
                                <font @click="change_cart(vo,1)" style="cursor:pointer"><i class="el-icon-plus"></i></font>
                            </span>
                        </el-col>
                        <!-- <el-col :span="3">
                            <span class="total">￥{{ numMulti(vo.price, vo.number) }}</span>
                        </el-col> -->
                        <el-col :span="5">
                            <span class="handle" @click="del_cart(vo)">移除</span>
                        </el-col>
                    </el-row>
                  </li>
              </ul>
          </div>
          </div>
          <!--<div class="store_goods_all_store_info">-->
                  <!--<ul>-->
                      <!--<li v-for="(vo,key) in cart_list" :key="key">-->
                          <!--<el-row>-->
                              <!--<el-col :span="1"><el-checkbox v-model="vo.checked" @change="handleCartListChange(key,k)"></el-checkbox></el-col>-->
                              <!--<el-col :span="13">-->
                                  <!--<div class="goods_thumb"><img width="40px" height="40px" :src="vo.picUrl" alt=""></div>-->
                                  <!--<div class="goods_title"><router-link :to="'/goods/info/'+vo.goodsId">{{vo.goodsName}}</router-link></div>-->
                                  <!--<div class="goods_spec" >{{vo.specifications.join(',')}}</div>-->
                              <!--</el-col>-->
                              <!--<el-col :span="2"><div class="price">￥{{vo.price}}</div></el-col>-->
                              <!--<el-col :span="4">-->
                                  <!--<div class="jian" @click="change_cart(vo,1,0)"><i class="el-icon-minus"></i></div>-->
                                  <!--<div class="nums"><input disabled v-model="vo.number" type="text"></div>-->
                                  <!--<div class="jia" @click="change_cart(vo,1,1)"><i class="el-icon-plus"></i></div>-->
                              <!--</el-col>-->
                              <!--<el-col :span="2"><div class="price" style="color:#333;font-weight:bold;">￥{{vo.number*vo.price}}</div></el-col>-->
                              <!--<el-col :span="2"><div class="remove" @click="del_cart(vo)">移除</div></el-col>-->
                          <!--</el-row>-->
                      <!--</li>-->
                  <!--</ul>-->
              <!--</div>-->
          </div>
          <!-- 没有购物车商品则 -->
          <div class="empty_show_list" v-else>
              <dl>
                  <dd><img src="@/static/img/cart/not-common-icon.png" alt=""></dd>
                  <dd class="btn">
                    <span>尚未添加产品至购物车</span>
                    <router-link to="/product/category">
                        <span>前往选购</span>
                    </router-link>
                  </dd>
              </dl>
          </div>
          <div class="store_goods_list">
              <div class="store_goods_list_title">
                  <el-row>
                    <div>
                      <el-col><el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox></el-col>
                    </div>
                    <div>
                      <div class="topay2">已选择<font color="#ca151e">{{total_num}}</font>件商品</div>
                      <!-- <div class="topay2">总价(不含运费)：<span>￥{{total_price}}</span></div> -->
                      <!-- <el-col :span="2"><div class="topay" @click="to_create">结算</div></el-col> -->
                      <div class="topay" @click="to_create">提交询价单</div>
                    </div>
                      
                  </el-row>
              </div>
          </div>
      </div>
      <footer-section></footer-section>
  </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
import { _local } from "@/plugins/local-storage.js"
export default {
    components: {
        HeaderSection,
        FooterSection,
    },
  props: {},
  data() {
    return {
        checkAll:false,
        checkStore:[],
        isIndeterminate:false,
        cart_list:[],
        store_list_check:[],
        total_price:0, // 统计价格
        total_num:0, // 统计数量
		cart_change:0 
    };
  },
  created() {
    this.get_cart_list();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
      // checkbox 选择
      handleCheckAllChange:function(e){
          if(e){
              // this.store_list_check.forEach(res=>{
              //     res.check = true;
              //     res.chose = false;
              // });
              this.cart_list.forEach(res=>{
                  // res.forEach(goodsRes => {
                      res.checked = true;
                  // });
              });
          }else{
              // this.store_list_check.forEach(res=>{
              //     res.check = false;
              //     res.chose = false;
              // });
              this.cart_list.forEach(res=>{
                  // res.forEach(goodsRes => {
                      res.checked = false;
                  // });
              });
          }
          let ids_array = new Array();
          let checked = 0;
          let i = 0;
          this.cart_list.forEach(res=>{
                  ids_array[i]=res.id;
                  checked = res.checked;
                  i++;
              });
          this.$post(this.$api.homeCheckedCart,{ids:ids_array,isChecked:checked});
          this.sum_price(); // 统计价格
      },
      // 商家checkbox
      handleStoreChange:function(e){
          if(this.store_list_check[e]['check'] == true && this.store_list_check[e]['chose'] == false){
              this.cart_list[e].forEach(res=>{
                  res.check = true;
              });
              this.isIndeterminate = false;
              this.checkAll = true;
          }
          if(this.store_list_check[e]['check'] == false && this.store_list_check[e]['chose'] == false){
              this.cart_list[e].forEach(res=>{
                  res.check = false;
              });
              this.isIndeterminate = false;
              this.checkAll = false;
          }
          if(this.store_list_check[e]['chose'] == true){
              this.cart_list[e].forEach((res)=>{
                  res.check = true;
              });
              this.store_list_check[e]['chose'] = false;
              this.isIndeterminate = true;
              this.checkAll = true;
          }
          this.sum_price(); // 统计价格
      },
      // 购物车列表checkbox
      handleCartListChange(vo){
          
          let checkedflag = true
          this.cart_list.forEach(item => {
            if(!item.checked){
                checkedflag = false
            }
          })

          if(checkedflag){
            this.checkAll = true
          }else{
            this.checkAll = false
          }

          let ids_array = new Array();
          let checked = 0;

          if(!this.$isEmpty(vo.checked)){
              ids_array[0]=vo.id;
              checked = vo.checked;
          }
          this.$post(this.$api.homeCheckedCart,{ids:ids_array,isChecked:checked});
          // this.$post(this.$api.homeCheckedCart,{ids:ids_array,isChecked:checked}).then(res=>{
          //     if(res.errno == 0){
          //         this.get_cart_list();
          //         return this.$message.success(res.msg);
          //     }else{
          //         return this.$message.error(res.msg);
          //     }
          // });
          this.sum_price(); // 统计价格
      },
      change_cart: function(info,type) {
          let data = {};
          // if (info && info.number == 1 && type==0) {
          //     this.del_cart(info);
          // } else {

            //   data.id = info.id;
            //   data.number = type == 0 ? info.number - 1 : info.number + 1;
            //   data.productId = info.productId;
            //   data.goodsId = info.goodsId;
              // data.change_type = type;    // 加还是减

              data['goodsId'] = Number(info.goodsId);
              data['productId'] = info.productId;
              data['checked'] = true
              data['number'] =  type == 0 ? info.number - 1 : info.number + 1;

              data['isInquiry'] = 1
              data['id'] = info.id
              data['goodsName'] = info.goodsName
              data['goodsSn'] = info.goodsSn
              data['skuId'] = info.skuId
              data['deleted'] = 0
              data['checked'] = info.checked
              data['brief'] = info.brief
                // delete this.data['detail']
                // delete this.data['addTime']
                // delete this.data['attributeCategoryId']
                // delete this.goods_info['sku_list']
                // delete this.goods_info['purposeId']
                // delete this.goods_info['shareUrl']
                // delete this.goods_info['gallery']
                // delete this.goods_info['addTime']
                // delete this.goods_info['updateTime']
                // delete this.goods_info['chose_attr']
                // delete this.goods_info['categoryId']
                // delete this.goods_info['chose_sku_id']
                const userId=JSON.parse(_local.get('user_info')).id;
                data['userId'] = userId
                // 以下字段待定
              data['picUrl'] = ''
              data['specifications'] = ''
              if(data['number'] === 0){
                this.$message.warning('产品只有最后一件，可点击移除清空此产品')
                return
              }
              this.$post(this.$api.homeChangeCart, data).then(res => {
                  //window.console.log(res);
                  if (res.code != 0) {
                      return this.$message.error(res.msg);
                  }
                  this.get_cart_list();
              });
          // }
      },
      del_cart:function(info){
          const params = {skuIds:[info.skuId]}
          this.$post(this.$api.homeDelCart,(params)).then(res=>{
              if(res.code === 0){
                  this.$message.success('产品移除成功');
                  this.get_cart_list();
              }else{
                  return this.$message.error(res.msg);
              }
          });
      },
      /**
	 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
	 * 
	 * @param num1加数1 | num2加数2
	 */
	numAdd(num1, num2){
		let baseNum, baseNum1, baseNum2;
		try {
			baseNum1 = num1.toString().split(".")[1].length;
		} catch (e) {
			baseNum1 = 0;
		}
		try {
			baseNum2 = num2.toString().split(".")[1].length;
		} catch (e) {
			baseNum2 = 0;
		}
		baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
		return (num1 * baseNum + num2 * baseNum) / baseNum;
	},
      sum_price:function(){
          let total_price = 0;
          let total_num = 0;
          this.cart_list.forEach(cartRes=>{
              // res.forEach(cartRes=>{
                  if(cartRes.checked){
                      total_price = this.numAdd(total_price, this.numMulti(cartRes.number,cartRes.price));
                      total_num += cartRes.number;
                  }
              // });
          });
          this.total_price = total_price;
          this.total_num = total_num;
      },
      // 前往设置收货地址
      to_create:function(){
          let chose_cart = [];
          this.cart_list.forEach(goodsRes=>{
                  if(!this.$isEmpty(goodsRes.checked) && goodsRes.checked == true){
                      chose_cart.push(goodsRes.id);
                  }
          });
          if(chose_cart.length<=0){
              return this.$message.warning('请前往选购产品！');
          }
          let cart_str = chose_cart.join(',');
          this.$router.push("/order/create_order/1/"+cart_str);
      },
      get_cart_list(){
            // this.cart_list=[]
            this.$get(this.$api.homeGetCartList).then(res=>{
              this.cart_list = res.data.cartList
              this.cart_change = res.data.cartTotal.goodsCount

              if(this.cart_list.length === 0){
                    this.checkAll = false
                }else{
                    this.checkAll = true
                }
              this.sum_price();
              this.store_list_check = [];
              this.cart_list.forEach(()=>{
                 this.store_list_check.push({check:false,chose:false}); 
              });
          });
      },
      //  防止小数相乘出现精度问题的乘法函数
        numMulti(num1, num2){
            let baseNum = 0;
            try {
                baseNum += num1.toString().split(".")[1].length;
            } catch (e) {
            }
            try {
                baseNum += num2.toString().split(".")[1].length;
            } catch (e) {
            }
            return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
        }
  }
};
</script>
<style lang="scss" scoped>
  .cart{
      min-width: 1100px;
  }
  .cart_body{
    padding-left: 10vw;
    padding-right: 10vw;
    background: #ffffff;
    min-height: 35vh;
    width:1280px;
    margin: 0 auto;
  }
  .goods_list{
      .goods_item{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          dt{
              width: 40px;
              height: 40px;
              background: #efefef;
              margin:0 10px;
              margin-left:30px;
              border-radius: 2px;
              img{
                  width: 40px;
                  height: 40px;
                  border-radius: 2px;
              }
          }
          dd{
              width: 285px;
          }
      }
      .el-row{
        >.el-col{
            display: flex;
            justify-content: center;
            align-items: center;
        }
        >:first-child{
            justify-content: flex-start;
        }
      }
      .el-col{
        .checkbox_goods{
            width:auto !important
        }
        >span{
            display: inline-block;
            width:100% !important;
            text-align: center;
        }
      }
      ul li{
          font-size: 14px;
          //border:1px solid #efefef;
          padding-left: 20px;
          padding-right: 20px;
          height: 60px;
          border-bottom: none;
          box-sizing: border-box;
          padding-top: 10px;
          &:last-child{
              border-bottom: 1px solid #efefef;
          }
          >span{
            text-align: center;
          }
          .attr{
              width: 320px;
          }
          .price{
              width: 100px;
          }
          .num{
              width: 150px;
              text-align: center;
              &:after{
                  content:'';
                  clear:both;
                  display: block;
              }
              font{
                  padding: 5px;
                  color: #666;
                  border: 1px solid #efefef;
              }
              input{
                  border:1px solid #efefef;
                  height: 32px;
                  width: 40px;
                  outline: none;
                  text-align: center;
                  margin:0;
              }
          }
          .total{
              width: 110px;
              font-weight: bold;
          }
          .handle{
              width:80px !important;
              background: #3538f3;
              text-align: center;
              line-height: 30px;
              width: 80px;
              color:#eeeded;
              border-radius: 3px;
              cursor: pointer;
          }
          .handle:hover{
              background: #476be2;
              color:#ffffff;
          }
      }
  }
  .store_list{
      padding:0px 20px;
      margin-bottom: 20px;
      .open_store{
          border:1px solid #ca151e;
          border-radius: 3px;
          color:#ca151e;
          margin-left: 15px;
          padding:2px 10px;
          font-size: 12px;
          cursor: pointer;
      }
  }
  .cart_table{
      //margin:20px;
  }
  .step_bar{
      margin:30px 0 20px;
  }
  .cart_th{
      background: #f5f5f5;
      padding:10px 20px;
      font-size: 14px;
      .el-row{
        margin-bottom: 0;
        .el-col{
            >span{
                width:100%;
                text-align: center;
            }
        }
      }
      >span{
        text-align: center;
      }
      .goods{
          width:320px;
          padding-left: 20px;
      }
      .price{
          width: 100px;
      }
      .attr{
          width: 310px;
      }
      .num{
          width: 150px;
      }
      .total{
          width: 110px;
      }
      .handle{
          width: 85px;
          text-align: center;
      }
      span{
          /*width: 120px;*/
          display: inline-block;
      }
  }
//old css====
.join_bzt{
  margin-top:30px;
}
.store_goods_list{
  margin-top: 20px;
  font-size: 14px;
  margin-bottom: 20px;
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #3538f3;
    border-color: #3538f3;
  }
  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: black
  }
  .store_goods_list_title{
      background: #f5f5f5;
      padding: 10px 20px;
      .el-row{
        margin-bottom: 0;
        align-items: center;
        justify-content: space-between;
        >:first-child{
            width:100px;
        }
        >:last-child{
            width:calc(100% - 100px);
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
      }
  }
  .topay{
      background: #3538f3;
      text-align: center;
      line-height: 35px;
      width: 120px;
      height: 35px;
      color:#fff;
      border-radius: 5px;
      font-size: 16px;
      cursor: pointer;
      margin-left:20px;
      margin-right: 50px;
  }
  .topay:hover{
      background: #476be2;
      text-align: center;
      line-height: 35px;
      width: 120px;
      height: 35px;
      color:#fff;
      border-radius: 5px;
      font-size: 16px;
      cursor: pointer;
  }
  .topay2{
      line-height: 35px;
      text-align: right;
      padding-right: 15px;
      font-size: 14px;
      font{
          padding:0 5px;
          font-size: 15px;
      }
      span{
          font-size: 15px;
          line-height: 30px;
          color:#ca151e;
      }
  }
}
.store_goods_all_store_info{
  margin-top: 20px;
  font-size: 14px;
  margin-left: 40px;
  span{
      padding:3px 8px;
      border:1px solid #ca151e;
      border-radius: 3px;
      color:#ca151e;
      margin-left: 15px;
  }
  ul{
      margin-top: 20px;
      margin-right: 40px;
      border:1px solid #efefef;
      li{
          border-bottom: 1px solid #efefef;
          padding-left: 20px;
          height: 60px;
          .el-checkbox{
              margin-top: 10px;
          }
          .goods_thumb{
              margin-top: 10px;
              float: left;
              margin-right: 15px;
              img{
                  border-radius: 3px;
              }
          }
          .goods_title{
              margin-top: 10px;
              
          }
          .goods_spec{
              float: left;
              color: #aaa;
          }
          .remove{
              color:#ca151e;
              line-height: 60px;
          }
          .price{
              line-height: 60px;
              color:#666;
          }
          .jia,.jian{
              line-height: 30px;
              padding:0 8px;
              color:#666;
              float: left;
              border: 1px solid #efefef;
              margin-top: 15px;
          }
          .nums{
              margin:0 10px;
              margin-top: 15px;
              float: left;
              width: 40px;
              input{
                  width: 40px;
                  height: 30px;
                  outline: none;
                  border:1px solid #efefef;
                  padding:0px 5px;
                  box-sizing: border-box;
                  color:#666;
              }
          }
      }
      li a{
          color:#666;
      }
      li a:hover{
          color:#ca151e;
      }
      li:after{
          content: "";
          display: block;
          clear: both;
      }
      li:last-child{
          border-bottom: none;
      }
  }
}
.empty_show_list{
    dl{
        display:flex;
        justify-content: flex-start;
        align-items: center;
        dd{
            float: none;
            a{
                text-align: center;
                span{
                    border:1px solid #3538f3;
                    margin:10px auto 0;
                    border-radius: 3px;
                    width:80px;
                    height:25px;
                    text-align: center;
                    line-height: 25px;
                    font-size: 14px;
                }
                span:hover{
                    border: 1px solid #476be2
                }
            }
            a:hover{
                color:#476be2
            }
            span{
                display:block;
            }
        }
        .btn{
            margin-top: 0;
            margin-left: 30px;
        }
    }
}
</style>